import axios from "axios";
import { Modal } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux";
import { notificationActions } from "../../data/notification";
import { useState } from "react";
import useT from "../../i18n/useT";

const SetContainerAsOpen = ({show, setHide, container_number}) => {
    const t = useT();
    const [openingDate, setOpeningDate] = useState("");
    const dispatch = useDispatch();
    const lang = useSelector((state) => state.user.language);
    
    const setOpenedHandler = () => {
        axios.put(`/api/containers/${container_number}/set-as-open`, { open_date: openingDate })
            .then(res => {
                dispatch(notificationActions.changeNotification({show: true, text: res.data.message[lang], type: "success-notification"}))
                setTimeout(() => {
                    dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                }, 4000);
                setHide(false);
            })
            .catch(error => {
                dispatch(notificationActions.changeNotification({show: true, text: error.response.data.message[lang], type: "error-notification"}))
                setTimeout(() => {
                    dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                }, 4000);
                setHide(false);
            });
    }

    return(
        <Modal show={show} onHide={() => setHide(false)} centered>
            <Modal.Header closeButton>
                <Modal.Title>{t("containers.setOpenTitle")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>{t("containers.setOpenConfirm1")} <strong>{container_number}</strong> {t("containers.setOpenConfirm2")}</p>
                <p>{t("containers.setOpenNote")}</p>
                <div className="form-group">
                    <label htmlFor="open_date">{t("containers.openDate")}:</label>
                    <input type="date" className="form-control" onChange={(e) => setOpeningDate(e.target.value)} id="open_date" name="open_date" required />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-secondary" onClick={() => setHide(false)}>{t("common.cancel")}</button>
                <button className="btn btn-primary" onClick={() => {
                    setOpenedHandler();
                }}>{t("containers.setAsOpen")}</button>
            </Modal.Footer>
        </Modal>
    )
}

export default SetContainerAsOpen